type IconProps = {
  className?: string
}

export const PackageIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth={1.8} aria-hidden>
    <path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5v-9Z" />
    <path d="M3.5 7.5 12 12m8.5-4.5L12 12m0 0v9" />
  </svg>
)

export const TruckIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth={1.8} aria-hidden>
    <path d="M2.5 7.5h12v8h-12zM14.5 10h4l2 2.5v3h-6z" />
    <circle cx="7.5" cy="17.5" r="1.8" />
    <circle cx="17.5" cy="17.5" r="1.8" />
  </svg>
)

export const SupportIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth={1.8} aria-hidden>
    <path d="M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z" />
    <path d="M8 9.5a4 4 0 0 1 8 0v1.5a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V9.5Zm0 0H6.5v2.5a2 2 0 0 0 2 2H10m6-4.5h1.5v2.5a2 2 0 0 1-2 2H14" />
  </svg>
)

export const MapPinIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth={1.8} aria-hidden>
    <path d="M12 21s6-5.2 6-10a6 6 0 1 0-12 0c0 4.8 6 10 6 10Z" />
    <circle cx="12" cy="11" r="2.2" />
  </svg>
)

export const CreditCardIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth={1.8} aria-hidden>
    <rect x="3" y="5.5" width="18" height="13" rx="2.2" />
    <path d="M3 10h18M7 14.5h4.5" />
  </svg>
)

export const ShieldIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth={1.8} aria-hidden>
    <path d="M12 3.5 5 6v5.8c0 4.4 2.9 7.3 7 8.7 4.1-1.4 7-4.3 7-8.7V6l-7-2.5Z" />
    <path d="m9.4 12 1.8 1.8 3.6-3.6" />
  </svg>
)

export const ChevronRightIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth={2} aria-hidden>
    <path d="m9 6 6 6-6 6" />
  </svg>
)

export const ArrowUpRightIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth={1.9} aria-hidden>
    <path d="M8 16 16 8M9.2 8H16v6.8" />
  </svg>
)

export const HelpCircleIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} stroke="currentColor" strokeWidth={1.8} aria-hidden>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.3 9.3a2.9 2.9 0 1 1 4.7 2.3c-.9.7-1.5 1.2-1.5 2.4" />
    <circle cx="12" cy="16.8" r=".8" fill="currentColor" stroke="none" />
  </svg>
)
